import React, { FC, useEffect, useState } from 'react'
import AOS from 'aos'
import dynamic from 'next/dynamic'
import ContactUsSection from 'components/ServicePage/ContactUsSection'
// import Testimonials from 'components/HomePage/Testimonials'

const Testimonials = dynamic(() => import('components/HomePage/Testimonials'), {
  ssr: false,
})
const BannerSec = dynamic(() => import('components/Common/BannerSec'), {
  ssr: false,
})
const OurClientsInner = dynamic(
  () => import('components/SubEmergingTechPage/OurClientsInner'),
  {
    ssr: false,
  }
)
const InnerTitleSec = dynamic(() => import('components/Common/InnerTitleSec'), {
  ssr: false,
})
const PortfolioSection = dynamic(
  () => import('components/ServicePage/PortfolioSection'),
  {
    ssr: false,
  }
)
const FaqSection = dynamic(() => import('components/ServicePage/FaqSection'), {
  ssr: false,
})
const HireDevelopers = dynamic(
  () => import('components/HomePage/HireDevelopers'),
  {
    ssr: false,
  }
)
const OurProcess = dynamic(() => import('components/ServicePage/OurProcess'), {
  ssr: false,
})
const FeatureBlock = dynamic(
  () => import('components/ServicePage/FeatureBlock'),
  {
    ssr: false,
  }
)
const ContactInformation = dynamic(
  () => import('components/HomePage/ContactInformation'),
  {
    ssr: false,
  }
)
const OurExpertiesSec = dynamic(() => import('./OurExpertiesSec'), {
  ssr: false,
})
const FsTechnology = dynamic(() => import('./FsTechnology'), {
  ssr: false,
})
const WhyGoFor = dynamic(() => import('./WhyGoFor'), {
  ssr: false,
})
const WdServiceList = dynamic(() => import('./WdServiceList'), {
  ssr: false,
})

const WebDevelopmentPage: FC = () => {
  useEffect(() => {
    AOS.init()
  }, [])
  const [contactPopup, setContactPopup] = useState(false)
  return (
    <>
      <BannerSec
        bannerimg="/assets/images/web-dev-img.svg"
        blueTitle="Web Development"
        blueTitle2=""
        title="Services"
        subTitle="Harness the power of the web with custom web apps, portfolio websites, and PWAs for true digital transformation for your business."
        blueButtonText1="Get"
        buttonText2="Started"
        bannerCtaUrl="/get-quote"
        altTag="Web Development Services"
      />
      <OurClientsInner />
      <InnerTitleSec
        title="Custom Web Application Development Services"
        subTitle="We are a web development company specializing in developing custom web products tailored to your core business needs. Right from the first wireframe to the last sign-off, our services are designed to boost profitability, ease of use, and data security."
      />
      <WdServiceList />
      <OurExpertiesSec />
      <FsTechnology />
      <div className="mb-5 pb-0 pb-xl-5">
        <HireDevelopers
          className=""
          data={{
            title: 'Hire Dedicated Web Developers For',
            bluetitle: 'Your Business',
            img: '/assets/images/hire-dev-img.jpg',
            desc: 'Work with a leading team of Developers, Testers, and Business Analysts who have successfully developed hundreds of web solutions. Our service delivery model provides you access to core IT talent affordably and effectively. Build your next web app and start scaling your business in the company of experts.',
            hireBtnUrl: '/get-quote',
            blueButtonText1: 'Hire',
            buttonText2: 'Professionals',
          }}
          setContactPopup={setContactPopup}
          contactPopup={contactPopup}
        />
      </div>
      <WhyGoFor />
      <OurProcess
        data={{
          title: 'Our Result-driven Web Development Process',
          tab_title_1: 'Discovery',
          tab_content_1:
            'Understanding and surveying project goals, requirements, and business landscape.',
          tab_title_2: 'Strategy',
          tab_content_2:
            'Building a technical plan for achieving project objectives with stakeholder support and client alignment.',
          tab_title_3: 'Design',
          tab_content_3:
            'Designing the initial prototypes, UI samples, and brainstorming ideas for best realizing the product outcomes.',
          tab_title_4: 'Programming',
          tab_content_4:
            'Converting ideas into comprehensible code structures in an iterative process, keeping project owners engaged.',
          tab_title_5: 'Support and Launch',
          tab_content_5:
            'Receiving final sign-off on the developed project and shifting it to a production server.',
        }}
      />
      <FeatureBlock
        data={{
          smallText: 'Do you have a project in mind?',
          title: 'Experience the power of Web Development with us!',
          imgLeft: '/assets/images/fp-srv-img.png',
          imgRight: '/assets/images/services/feature-block-img.png',
          btnLink: '/get-quote',
        }}
      />
      <PortfolioSection
        className="pf_sec_grey"
        data={{
          title: 'Our Portfolio',
          subTitle:
            'WebClues has proved its mettle over time in different web development projects across boundaries and as a matter of fact, here are some of our prestigious projects you can check upon.',
        }}
      />
      <Testimonials
        data={{
          title: 'Our customers love what we do',
          text: [
            'Our metrics of success are meeting client goals and enabling them to proliferate in the market. For us, the client should always take the center stage and our top priority is to ensure we deliver all our projects par excellence.',
            'These principles have helped us build a dedicated client base around the world, positioning us as a key Web Development Services provider.',
          ],
        }}
      />
      <FaqSection
        data={{
          title: 'FAQs',
          subTitle: '',
        }}
      />
      <ContactUsSection
        data={{
          title: 'Hi! Ping Us',
          subTitle: 'Contacting us is the first step towards success.',
        }}
      />
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
    </>
  )
}

export default WebDevelopmentPage
